/**
 * The door to the `large-upload` chunk: the direct, resumable upload lane
 * (largeUploadLane.ts) that carries every file past the proxy lane's 30 MiB,
 * and the fallback for a smaller one the proxy could not place (2026-10-08, the
 * 50 GB raise).
 *
 * Fetched the first time a file needs it; most attachments never do. A failed
 * download is forgotten (createOnDemandModule), so the next upload fetches it
 * again, and retryImport retries a transient failure.
 *
 * IN THE CHAT ENGINE, so it holds nothing but the one dynamic import. The lane
 * is loaded here and nowhere else (scripts/check-chat-first-paint.mjs, R4).
 */
import { createOnDemandModule } from './onDemandModule';
// TYPE-only import: erased at build, never an edge into the chunk.
import type * as LargeUploadLaneNamespace from './largeUploadLane';

export type LargeUploadLaneModule = typeof LargeUploadLaneNamespace;

const lane = createOnDemandModule<LargeUploadLaneModule>(
  () => import(/* webpackChunkName: "large-upload" */ './largeUploadLane'),
);

/** The lane, fetched now if it has not arrived. A failed download rejects and is forgotten. */
export const loadLargeUploadLane: () => Promise<LargeUploadLaneModule> = lane.load;
